import { render } from "./BillingIconTile.vue?vue&type=template&id=3cda0552&scoped=true"
import script from "./BillingIconTile.vue?vue&type=script&lang=js"
export * from "./BillingIconTile.vue?vue&type=script&lang=js"

import "./BillingIconTile.vue?vue&type=style&index=0&id=3cda0552&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cda0552"]])

export default __exports__